import { Action, Dispatch } from 'redux'
import axios from 'axios'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth } from 'firebase/index'
import { CANCEL_CHECKOUT_ENDPOINT } from 'constants/urls'
import { fetchOrdersAction } from 'reducks/checkout/actions'
import { closeCautionModalAction } from 'reducks/modal/actions'

const cancelCheckout = (checkoutId: string) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const storeRef = getState().auth.store_ref
    const orders = getState().checkout.orders
    dispatch(showLoadingAction())
    // トークンを再取得する
    const token = await auth.currentUser?.getIdToken()
    if (typeof !token === 'undefined') {
      console.error('認証トークンの取得に失敗しました。')
      return
    }
    try {
      await axios.post(
        CANCEL_CHECKOUT_ENDPOINT,
        { checkout_id: checkoutId, store_id: storeRef.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      const nextOrders = orders
      const index = orders.findIndex((order) => order.checkout_id && order.checkout_id === checkoutId)
      nextOrders[index].status = 'canceled'
      dispatch(fetchOrdersAction(nextOrders))
      dispatch(hideLoadingAction())
      dispatch(closeCautionModalAction())
    } catch (e) {
      console.error(e)
      dispatch(hideLoadingAction())
      return
    }
  }
}

export default cancelCheckout
